import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const Services = () => {
  const services = [
    {
      title: 'Briefkonsolidierung & Versandoptimierung',
      items: [
        'Dauerhaft niedrigere Brief- und Versandkosten statt einmaliger Effekte',
        'Spürbar niedrigere Portokosten durch Bündelung — ohne Umstellung Ihrer Abläufe',
        'Belastbare Kostenmodelle, mit denen Einkauf und Management sicher entscheiden',
        'Klarheit über Ihr tatsächliches Einsparpotenzial statt Bauchgefühl',
        'Eine umsetzungsreife Zielstruktur mit klaren, nachvollziehbaren Konditionen',
        'Reibungsloser Übergang in den Regelbetrieb — ohne Störung des Tagesgeschäfts'
      ],
      accent: 'left'
    },
    {
      title: 'Versand- & Postlogistik',
      items: [
        'Volle Transparenz über Ihre Versand- und Poststellenstrukturen',
        'Weniger Komplexität und weniger Dienstleister — einfacher zu steuern',
        'Verlässliche Qualität, planbare Laufzeiten und zuverlässige Prozesse',
        'Klare Einschätzung, wo Ihre Prozesse Geld und Zeit kosten',
        'Höhere Prozessqualität bei besserer Steuerbarkeit im Alltag'
      ],
      accent: 'top'
    },
    {
      title: 'Strategie & Umsetzung',
      items: [
        'Fundierte Entscheidungsgrundlagen für Einkauf und Management',
        'Ein Ansprechpartner von der Analyse bis zum stabilen Regelbetrieb',
        'Einsparungen, die dauerhaft wirken statt nur einmalig',
        'Ein realistischer Fahrplan, auf den Sie sich verlassen können',
        'Persönliche Begleitung, bis die Umstellung nachweislich läuft'
      ],
      accent: 'right'
    }
  ];

  return (
    <section id="leistungen" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Leistungsbereiche
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Drei Schwerpunkte für nachhaltige Kostensenkung und operative Exzellenz
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              key={index}
              className="border-slate-200 hover:shadow-2xl transition-all duration-500 group relative overflow-hidden backdrop-blur-sm bg-white/80 hover:-translate-y-2"
            >
              {/* Decorative accent line */}
              <div className={`absolute ${service.accent === 'top' ? 'top-0 left-0 right-0 h-1' : service.accent === 'left' ? 'left-0 top-0 bottom-0 w-1' : 'right-0 top-0 bottom-0 w-1'} bg-gradient-to-r from-slate-700 to-slate-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
              
              {/* Subtle background effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-slate-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <CardHeader className="relative z-10">
                <CardTitle className="text-xl font-semibold text-slate-900 leading-tight group-hover:text-slate-800 transition-colors">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="relative z-10">
                <ul className="space-y-3">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start group/item">
                      <span className="inline-block w-1.5 h-1.5 bg-slate-800 rounded-full mt-2 mr-3 flex-shrink-0 group-hover/item:scale-150 transition-transform duration-300"></span>
                      <span className="text-slate-600 leading-relaxed group-hover/item:text-slate-700 transition-colors">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;